export default {"src":"/_next/static/media/logo.616b5b31.svg","height":52,"width":51,"blurWidth":0,"blurHeight":0};